<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-03-14 09:54:57
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2024-05-06 10:50:25
 * @FilePath: \hxt-saas-pc\src\views\CourseManage\CourseForm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="add-select-course-container">
        <Header></Header>
        <div class="box">
            <div class="header-wrapper">
                <div class="header-line-block"></div>
                <div class="header-title">课程管理</div>
            </div>
            <div class="search-container">
                <div class="search-title">
                    <span>课程管理名称</span>
                    <span class="require">*</span>
                </div>
                <div class="input-wrapper">
                    <el-input placeholder="输入课程管理名称" v-model="courseTitle">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
            </div>

            <div class="students-course-container">
                <div class="parts-container">
                    <div class="title-wrapper">
                        <span>已选学员</span>
                        <span class="require">*</span>
                        <el-button type="primary" style="margin-left: 310px" @click="usersHOW">选择学员</el-button>
                    </div>
                    <div class="parts-wrapper">
                        <div class="parts-header">
                            <div class="left"></div>
                            <div class="right">已选择{{ this.filteredItems.length }}人</div>
                        </div>
                    <div class="ports-content">
                        <div class="search-wrapper">
                            <el-input v-model="searchQuery" placeholder="请输入学员名称">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                <span slot="suffix" class="btn animate">搜索</span>
                            </el-input>

                            <!-- <el-autocomplete popper-class="my-autocomplete" v-model="searchStudent"
                                    :fetch-suggestions="queryStudent" :trigger-on-focus="true" placeholder="请选择学员"
                                    @select="handleSelectStudent" style="width:100%;">
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                    <template slot-scope="{ item }">
                                        <div class="operate-wrapper">
                                            <span style="font-size: 22px;color: #333333;">
                                                {{ item.userName }}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    <span style="margin-left:10px;">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    {{ item.mobile }}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </span>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            </span>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <div style="float: right;font-size: 18px;color: #3E63EE;">添加</div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    </template>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </el-autocomplete> -->
                            </div>
                            <div class="students-wrapper">
                                <div v-for="(item, key) in filteredItems" :key="key" class="students-row">
                                    <div class="info">
                                        <span>{{ item.name }}</span>
                                        <span class="gap">{{ item.mobile }}</span>
                                    </div>
                                    <div class="btn animate" @click="handleDeleteStudent(item)">
                                        移除
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="parts-container gap">
                    <div class="title-wrapper">
                        <span>已选课程</span>
                        <span class="require">*</span>
                        <el-button type="primary" style="margin-left: 310px" @click="xzkc">选择课程</el-button>
                    </div>
                    <div class="parts-wrapper">
                        <div class="parts-header">
                            <div class="left">
                                <!--<el-checkbox v-model="checkedAll" @change="selectAll">全选</el-checkbox>-->
                            </div>
                            <div class="right">已选择{{ filteredItems2.length }}门</div>
                        </div>
                        <div class="ports-content">
                            <div class="search-wrapper">
                                <el-input placeholder="请输入课程名称" v-model="searchQuery2" style="width: 100%">
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                    <span slot="suffix" class="btn animate">搜索</span>
                                </el-input>
                            </div>
                            <div class="course-wrapper">
                                <div v-for="(item, key) in filteredItems2" :key="key" class="course-row">

                                <div> {{ item.courseName }}</div>
                                <div class="teacher">录播 | {{ item.courseTime }}分钟</div>
                                <!-- <div class="teacher">讲师：{{ item.teacherName }}</div> -->
                                    <div class="btn animate" @click="handleDeleteStudent2(item)">
                                        移除
                                    </div>
                                </div>
                                <!-- <div v-if="courseData.length > 0 && currentPage < totalPages" class="more-btn"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    @click="viewMore">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    查看更多
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-container">
                <div class="btn animate deal" @click="handleSubmit">完成</div>
                <div class="btn animate cancel" @click="handleCancel">取消</div>
            </div>
        </div>

        <addxy ref="addxy" @setuseList="setUserDate"></addxy>
        <addkc ref="addkc" @setKCdATE="kcDATA"></addkc>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import {
    groupCompanyMemberList,
    studyMemberList,
    studyRecordCourseList,
    saveOrUpdateCourseGroup,
    courseGroupDetail,
} from "@/api/index.js";
import addxy from "./addxy";
import addkc from './addkc';
export default {
    name: "",

    components: {
        Header,
        addxy, addkc
    },
    data() {
        return {
            searchQuery2: "",
            searchQuery: "",
            row: "",
            status: "",
            dept: "",
            token: "",
            courseTitle: "",
            checkedAll: false,
            searchStudent: "",
            studentsData: [],
            /**选择的学员 */
            studentOptions: [],
            searchCourse: "",
            courseData: [],
            newcourseData: [],
            currentPage: 1,
            totalPages: 1,
            totalRows: 0,
            /**选择的课程 */
            courseOptions: [],
            totalCourse: 0,
            isFirst: true,
            useList: [],
            userALL: [],
            NewuserList: [], courseGroupId: 0,
        };
    },
    created() {
        if (this.$router.history.current.query.data) {
            this.row = JSON.parse(this.$router.history.current.query.data);
            // console.log('*************', this.row);
            this.status = "course-edit";
        }
        this.dept = localStorage.getItem("dept");
        this.token = localStorage.getItem("token");

    },
    computed: {


        filteredItems() {
            // 使用 filter 方法过滤 items 数组
            // 搜索查询为空时返回所有项
            // 否则返回匹配查询的项
            return this.searchQuery
                ? this.userALL.filter((item) =>
                    item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                )
                : this.userALL;
        },
        filteredItems2() {
            // 使用 filter 方法过滤 items 数组
            // 搜索查询为空时返回所有项
            // 否则返回匹配查询的项
            return this.searchQuery2
                ? this.newcourseData.filter((item) =>
                    item.courseName.toLowerCase().includes(this.searchQuery2.toLowerCase())
                )
                : this.newcourseData;
        },
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;

        this.queryCourseData();
        this.getMemberList();
    },
    methods: {
        xzkc() {

            this.$refs.addkc.shwo()
        },
        kcDATA(data) {


            this.newcourseData = this.mergeAndRemoveDuplicates(this.newcourseData, data)

        },
        usersHOW() {
            this.$refs.addxy.shwo(this.courseGroupId)
        },
        setUserDate(list) {
            console.log(list, 'list');
            this.useList = this.mergeArraysWithoutDuplicates(this.useList, list);
            this.userALL = this.compareArraysById(this.useList, this.NewuserList);
        },
        //课程去重
        mergeAndRemoveDuplicates(array1, array2) {
            // 用于存储已经出现的 courseId
            let courseIdSet = new Set();

            // 创建新数组，将第一个数组的所有元素添加到其中
            let mergedArray = [...array1];

            // 遍历第一个数组，将 courseId 添加到集合中
            array1.forEach(item => courseIdSet.add(item.courseId));

            // 遍历第二个数组，检查 courseId 是否已存在，如果不存在则添加到新数组中
            array2.forEach(item => {
                if (!courseIdSet.has(item.courseId)) {
                    mergedArray.push(item);
                    courseIdSet.add(item.courseId);
                }
            });

            return mergedArray;
        },
        //学员合并数组并且去除重复的
        mergeArraysWithoutDuplicates(arr1, arr2) {
            // 将两个数组合并到一个 Set 中
            const mergedSet = new Set([...arr1, ...arr2]);
            // 将 Set 转换回数组
            const mergedArray = Array.from(mergedSet);
            return mergedArray;
        },
        getMemberList() {
            groupCompanyMemberList(
                {
                    pageNum: 1,
                    pageSize: 10000, //不想分页可以传个超级大的数
                    keyword: "", //关键字
                },
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            ).then((res) => {

                if (res.code == 200) {
                    this.NewuserList = res.data.list;
                    this.userALL = this.compareArraysById(this.useList, res.data.list);

                }
            });
        },
        //过滤用户
        compareArraysById(array1, array2, propertyName = 'userId') {
            //courseId

            // 使用 filter 和 find 方法找出两个数组中ID相同的元素
            return array1
                .filter((item1) => array2.some((item2) => item1 === item2[propertyName]))
                .map((item1) => {
                    // 使用 find 方法找到 array2 中具有相同 ID 的元素
                    const matchingItem2 = array2.find((item2) => item1 === item2[propertyName]);
                    // 如果找到了，合并两个对象的属性；否则只返回 array1 中的元素
                    return matchingItem2 ? { ...item1, ...matchingItem2 } : item1;
                });
        },
        async queryStudent(queryString, callback) {
            this.studentsData = [];
            await studyMemberList(
                {
                    keyword: queryString,
                },
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        this.studentsData = res.data;
                        callback(this.studentsData);
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
        searchCourseData() {
            this.currentPage = 1;
            this.courseData = [];
            this.queryCourseData();
        },
        async queryCourseData() {
            await studyRecordCourseList(
                {
                    deptId: 0,
                    keyword: this.searchCourse,
                    pageNum: this.currentPage,
                    pageSize: 10000,
                },
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        let data = res.data.list;
                        let newArr = data.map((item) => {
                            item["value"] = false;
                            return item;
                        });
                        const tableArr = this.courseData;
                        this.courseData = tableArr.concat(newArr);
                        this.totalPages = res.data.totalPages;
                        this.totalRows = res.data.totalRecords;
                        /**编辑回显 */
                        if (this.status == "course-edit") {
                            // console.log('编辑回显')
                            this.getCourseDetail();
                        }
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
        viewMore() {
            const currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.queryCourseData();
            } else {
                this.$message({
                    message: "没有更多了",
                    type: "warning",
                });
            }
        },
        async getCourseDetail() {
            const row = this.row;
            await courseGroupDetail(
                row.courseGroupId,
                {},
                {
                    Authorization: this.token,
                    DeptId: this.dept,
                }
            )
                .then((res) => {
                    if (res.code == 200) {
                        console.log(res, '获取课程详情数据')
                        const data = res.data;
                        this.courseTitle = data.courseGroupName;
                        this.courseGroupId = res.data.courseGroupId
                        // this.editInit(data);

                        this.useList = data.studyMemList.map(item => { return item.userId })
                        this.userALL = this.compareArraysById(this.useList, this.NewuserList);
                        var kcList = data.courseList.map(item => { return item.courseId })
                        this.newcourseData = this.compareArraysById(kcList, this.courseData, 'courseId');
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
        editInit(data) {
            let courseList = data.courseList;
            if (this.isFirst) {
                this.studentOptions = data.studyMemList;
                this.courseOptions = data.courseList;
            } else {
                courseList = this.courseOptions;
            }
            let a = this.courseData;
            for (let i = 0; i < courseList.length; i++) {
                let item = courseList[i];
                for (let j = 0; j < courseData.length; j++) {
                    let itemCourse = courseData[j];
                    if (item.courseId == itemCourse.courseId) {
                        this.courseData[j]["value"] = true;
                    }
                }
            }
            this.isFirst = false;
        },
        handleSelectStudent(row) {
            const studentOptions = this.studentOptions;
            let isHas = false;
            let myPromise = new Promise((resolve, reject) => {
                studentOptions.forEach((item) => {
                    if (item.userId == row.userId) {
                        isHas = true;
                    }
                });
                resolve();
            });
            myPromise.then(() => {
                if (isHas) {
                    this.$message({
                        message: "此学员已经添加",
                        type: "warning",
                    });
                } else {
                    this.studentOptions.push(row);
                }
            });
        },
        handleDeleteStudent(row) {
            this.$confirm("确认移除此学员吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    //this.deleteStudent(row);

                    this.userALL = this.userALL.filter(
                        (item) => item.userId !== row.userId
                    );
                    this.useList = this.useList.filter(
                        (k) => k !== row.userId
                    );
                    console.log(this.userALL, '888888888888', this.useList)
                })
                .catch(() => { });
        },
        handleDeleteStudent2(row) {
            this.$confirm("确认移除此课程吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    //this.deleteStudent(row);

                    this.newcourseData = this.newcourseData.filter(
                        (item) => item.courseId !== row.courseId
                    );
                })
                .catch(() => { });
        },
        deleteStudent(row) {
            const studentOptions = this.studentOptions;
            this.studentOptions = studentOptions.filter((item) => {
                return item.userId != row.userId;
            });
        },
        changeCourse(row) {
            if (row.value) {
                this.courseOptions.push(row);
            } else {
                let courseOptions = this.courseOptions;
                this.courseOptions = courseOptions.filter((item) => {
                    return item.courseId != row.courseId;
                });
            }
            // console.log(this.courseOptions);
        },
        handleCancel() {
            this.$router.go(-1);
            //this.$emit('courseStatus', 'course-list');
        },
        async handleSubmit() {
            if (this.courseTitle == "") {
                this.$message({
                    message: "请输入课程管理名称",
                    type: "error",
                });
                return;
            }
            if (this.userALL.length == 0) {
                this.$message({
                    message: "请选择学员",
                    type: "error",
                });
                return;
            }
            if (this.newcourseData.length == 0) {
                this.$message({
                    message: "请选择课程",
                    type: "error",
                });
                return;
            }
            //学员
            const studyMemIdList = this.userALL.map((item) => {
                return item.userId;
            });
            //课程
            const courseIdList = this.newcourseData.map((item) => {
                return item.courseId;
            });
            let params = {
                courseGroupName: this.courseTitle,
                courseIdList: courseIdList,
                deptId: 0,
                studyMemIdList: studyMemIdList,
                userId: 0,
            };
            // console.log('*************',this.row);
            if (this.status == "course-edit") {
                //  const row = JSON.parse(this.row);
                const row = this.row;
                params["courseGroupId"] = row.courseGroupId;
            }
            await saveOrUpdateCourseGroup(params, {
                Authorization: this.token,
                DeptId: this.dept,
            })
                .then((res) => {
                    if (res.code == 200) {
                        this.$router.go(-1);
                        // this.$emit('courseStatus', 'course-list');
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                    return;
                })
                .catch((err) => {
                    // console.log(err);
                });
        },
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 1200px;
    margin: 0 auto;
    background: #ffffff;
}

.animate {
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.add-select-course-container {
    min-height: calc(100vh - 140px);

    border-radius: 8px;
    border: 1px solid #f0f0f3;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .header-wrapper {
        display: flex;
        align-items: center;
        margin-top: 32px;
        margin-bottom: 43px;
        position: relative;
        left: 0px;

        .header-line-block {
            width: 6px;
            height: 24px;
            background: #3e63ee;
            border-radius: 3px;
        }

        .header-title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3e63ee;
            margin-left: 45px;
        }
    }

    .search-container {
        margin: 40px 45px 40px 45px;

        .search-title {
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 42px;

            .require {
                color: #eb6c48;
            }
        }

        .input-wrapper {
            margin-top: 20px;
            width: 520px;
        }
    }

    .students-course-container {
        flex: 1;
        margin: 0px 45px 0px 45px;
        display: flex;
        justify-content: space-between;

        .parts-container {
            height: 100%;
            flex: 1;

            .title-wrapper {
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;

                .require {
                    color: #eb6c48;
                }
            }

            .parts-wrapper {
                background: #ffffff;
                border-radius: 8px;
                border: 1px solid #cbcbcb;
                margin-top: 16px;
                display: flex;
                flex-direction: column;

                .parts-header {
                    height: 52px;
                    background: #f7f7f8;
                    border-radius: 8px 8px 0px 0px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .left {
                        margin-left: 28px;

                        /deep/ .el-checkbox {
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        /deep/ .el-checkbox__label {
                            font-size: 20px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }
                    }

                    .right {
                        margin-right: 29px;
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #606a74;
                    }
                }

                .ports-content {
                    flex: 1;
                    padding: 19px 0px 0px 0px;
                    display: flex;
                    flex-direction: column;

                    .search-wrapper {
                        height: 40px;
                        padding: 0px 29px 0px 29px;

                        .btn {
                            font-size: 18px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #3e63ee;
                            line-height: 40px;
                            margin-right: 15px;
                        }

                        .btn:hover {
                            cursor: pointer;
                            opacity: 0.8;
                        }

                        .operate-wrapper {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .info {
                                font-size: 22px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;
                                line-height: 30px;
                                display: inline-block;
                            }

                            .add-btn {
                                color: #3e63ee;
                                cursor: pointer;
                                display: inline-block;
                            }
                        }
                    }

                    .students-wrapper {
                        height: 570px;
                        overflow-x: hidden;
                        overflow-y: auto;

                        .students-row {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 20px 0px 20px 0px;
                            margin: 0px 30px 0px 30px;
                            border-bottom: 1px solid #eaeaea;

                            .info {
                                font-size: 22px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;

                                .gap {
                                    margin-left: 10px;
                                }
                            }

                            .btn {
                                font-size: 18px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #3e63ee;
                            }

                            .btn:hover {
                                cursor: pointer;
                                opacity: 0.8;
                            }
                        }
                    }

                    .course-wrapper {
                        height: 570px;
                        overflow-x: hidden;
                        overflow-y: auto;

                        .course-row {
                            padding: 20px 0px 20px 0px;
                            margin: 0px 30px 0px 30px;
                            border-bottom: 1px solid #eaeaea;
                            position: relative;

                            /deep/ .el-checkbox {
                                display: flex;
                            }

                            /deep/ .el-checkbox__input {
                                display: inline-block;
                                margin-top: 8px;
                            }

                            /deep/ .el-checkbox__label {
                                font-size: 22px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #333333;
                                line-height: 30px;
                                width: 428px;
                                white-space: normal;
                                word-break: break-all;
                            }

                            .teacher {
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #606a74;
                                line-height: 22px;
                                margin-top: 8px;
                                // margin-left: 25px;
                            }


                            .animate {
                                position: absolute;
                                right: 0;
                                top: 40px;
                                font-size: 18px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #3e63ee;
                                line-height: 40px;
                                margin-right: 15px;
                            }

                            .animate:hover {
                                cursor: pointer;
                                opacity: 0.8;
                            }
                        }

                        .more-btn {
                            text-align: center;
                            margin: 15px 0px 15px 0px;
                            font-size: 14px;
                            color: #606a74;
                        }

                        .more-btn:hover {
                            cursor: pointer;
                            color: #3e63ee;
                        }
                    }
                }
            }
        }

        .gap {
            margin-left: 70px;
        }
    }

    .btn-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 29px 45px 0px 45px;
        padding: 39px 0px 68px 0px;

        .btn {
            width: 108px;
            height: 42px;
            border-radius: 6px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .deal {
            border: 1px solid #4f79ed;
            background: #3e63ee;
            color: #fff;
        }

        .deal:hover {
            cursor: pointer;
            opacity: 0.8;
        }

        .cancel {
            border: 1px solid #4f79ed;
            color: #3e63ee;
            margin-left: 20px;
        }

        .cancel:hover {
            cursor: pointer;
            background: #3e63ee;
            color: #fff;
        }
    }
}
</style>


